import Component from "@glimmer/component"
import type { CardStack } from "@shared/models/card-stack"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"

interface Signature {
  Args: {
    cardStack: CardStack
    planbook: Planbook
    course?: Course
  }
}

export default class CustomizeTemplate extends Component<Signature> {}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Course::CreateEdit::CustomizeTempl": typeof CustomizeTemplate
  }
}
